import { Component } from '@angular/core';
import { EkButtonComponent } from '@beta-foundations/ui-kit/buttons';
import { EkDialogBodyComponent, EkDialogFooterComponent, EkDialogHeaderComponent } from '@beta-foundations/ui-kit/overlay/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-logout-message',
  standalone: true,
  imports: [EkDialogHeaderComponent,
      EkDialogBodyComponent,
      EkDialogFooterComponent,
      EkButtonComponent,
      TranslateModule],
  templateUrl: './logout-message.component.html',
  styleUrl: './logout-message.component.scss'
})
export class LogoutMessageComponent {
  
  constructor(public ref: DynamicDialogRef) {}

  onConfirm() {
    this.ref.close(true);
  }

  onCancel() {
    this.ref.close(false);
  }
}
